import { useEffect, useState } from 'react';
import { templateLegacyParser } from '../../../../../../pages/Agenda/Agenda.functions';
import { AgendaService } from '../../../../../../pages/Agenda/Agenda.service';
import {
  tOption,
  tTemplate,
} from '../../../../../../pages/Agenda/Agenda.types';
import {
  getAllowedFields,
  getInterval,
  removeEmpty,
  removeFields,
} from '../../../../../../pages/Agenda/components/Calendar/Calendar.functions';
import {
  tCreateEventForm,
  tCreateEventRequest,
} from '../../../../../../pages/Agenda/components/Calendar/Calendar.types';
import { useUserContext } from '../../../../../../providers/UserProvider/User.context';
import { useWorkspaceContext } from '../../../../../../providers/WorkspaceProvider/Workspace.context';
import { ChatEnum } from '../../../../Chat.enum';
import { useMessageBarContext } from '../../MessageBar.hook';
import { tAgendaActionContext } from './Agenda.types';
import { useModalsContext } from '../../../../../../providers/ModalsProvider/Modals.context';
import { LLog, LOG_COMPONENTS, LOG_OPERATIONS } from 'src/lib/logging';

export default function useAgendaAction(): tAgendaActionContext {
  const { currentWorkspace } = useWorkspaceContext();
  const [currentTemplates, setCurrentTemplates] = useState<tTemplate[]>([]);
  const { currentUser } = useUserContext();
  const { selectedLeadForChatModal } = useModalsContext();
  const { setSelectedAction } = useMessageBarContext();

  useEffect(() => {
    (async () => {
      if (!currentWorkspace) return;

      const response = await AgendaService.getCurrentTemplates(
        currentWorkspace.id,
      );

      if (response) {
        setCurrentTemplates(
          response.data.templates.map((template) =>
            templateLegacyParser(template, currentWorkspace.id),
          ),
        );
      }
    })();
  }, [currentWorkspace]);

  async function onCreateChatEventSubmit(values: tCreateEventForm) {
    try {
      const formDate = getInterval({
        date: values.startDate.toISOString(),
        duration: values.duration,
        time: values.time.toISOString(),
      });

      let createEventRequest: Partial<tCreateEventRequest> = {
        template_id: values.templateId,
        workspace_id: currentWorkspace?.id || '',
        name: values.title,
        start_date: formDate.startDate,
        end_date: formDate.endDate,
        user_id: currentUser?.authId,
        note: values.note,
        address: values.address,
        links: [values.link],
        description: values.description || '',
        guests: values.guests.map((guest: tOption) => guest.value),
      };

      const allowedFields = getAllowedFields(currentTemplates, values);
      if (!allowedFields.users) {
        createEventRequest.guests = [];
      }
      createEventRequest = removeEmpty(createEventRequest);
      createEventRequest = removeFields(createEventRequest, allowedFields);

      await AgendaService.createAgendaLeadEvent(
        createEventRequest,
        selectedLeadForChatModal?.id ?? '',
      );
      setSelectedAction(ChatEnum.CHAT);
    } catch (err) {
      LLog.error(
        {
          component: LOG_COMPONENTS.CHAT,
          method: 'AgendaAction.hook',
          operation: LOG_OPERATIONS.ERROR,
        },
        'Error en AgendaAction',
        err as unknown as Error,
      );
    }
  }

  return {
    templates: currentTemplates,
    onCreateChatEventSubmit,
  };
}
